import React from 'react';
import { Button } from './Button';
import { motion } from 'framer-motion';
export const Hero = () => {
  return <section className="pt-20 pb-16 md:pt-32 md:pb-24 px-6 max-w-6xl mx-auto grid md:grid-cols-2 gap-12 items-center" data-id="element-26">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      duration: 0.6
    }} className="space-y-8" data-id="element-27">
        <div className="space-y-4" data-id="element-28">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-serif text-charcoal leading-tight" data-id="element-29">
            Duerme, Bebé, Duerme: El Método de los 14 Días para Recuperar tus
            Noches (y tu Vida)
          </h1>
          <h2 className="text-xl md:text-2xl text-charcoal/80 font-sans" data-id="element-30">
            Logra que tu hijo duerma su primer bloque de 7 horas en menos de dos
            semanas, sin dejarlo llorar solo y sin métodos traumáticos.
          </h2>
        </div>

        <p className="text-lg text-charcoal/70 leading-relaxed" data-id="element-31">
          Son las 3:15 de la madrugada. Estás en el pasillo, meciendo un peso
          que parece no tener fin, con los ojos ardidos y el corazón acelerado.
          Te preguntas por qué otros bebés duermen y el tuyo parece tener un
          interruptor magnético que lo despierta en cuanto toca la cuna.
        </p>
        <p className="text-lg text-charcoal/70 leading-relaxed" data-id="element-32">
          El agotamiento crónico no es una "etapa normal" de la paternidad que
          debas sufrir en silencio. Es un riesgo para tu salud, para tu pareja y
          para el desarrollo de tu bebé.
        </p>

        <div className="pt-4" data-id="element-33">
          <Button data-id="element-34">¡QUIERO RECUPERAR MI SUEÑO AHORA!</Button>
        </div>
      </motion.div>

      <motion.div initial={{
      opacity: 0,
      scale: 0.95
    }} animate={{
      opacity: 1,
      scale: 1
    }} transition={{
      duration: 0.6,
      delay: 0.2
    }} className="relative" data-id="element-35">
        <div className="absolute inset-0 bg-beige rounded-2xl transform rotate-3 scale-105 -z-10 opacity-50" data-id="element-36"></div>
        <img src="https://cdn.magicpatterns.com/uploads/oLLbMmRLoctG3Nwmifrv8N/heylloyd-image-1778019944598.png" alt="Método Adormecer en tablet" className="rounded-2xl shadow-xl w-full object-cover" data-id="element-37" />
      </motion.div>
    </section>;
};